import React, { useState, useEffect, useCallback } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import { supabase } from '../lib/supabase'
import { sendNotaryAssignment, sendStatusUpdate, sendJobCompleted, sendPaymentSent, sendBlastInvite } from '../lib/email'
import { smsNotaryAssignment } from '../lib/sms'
import { trackOffer } from '../lib/metrics'
import toast from 'react-hot-toast'
import JobMessages from '../components/JobMessages'

// ── STYLES ────────────────────────────────────────────────────
const STYLES = `
  .ajd-wrap { max-width:1200px; margin:0 auto; padding:0 0 48px; }
  .ajd-back { display:inline-flex; align-items:center; gap:6px; color:#7A7870; font-size:12px; background:none; border:none; cursor:pointer; padding:0; margin-bottom:16px; font-family:inherit; transition:color 0.2s; }
  .ajd-back:hover { color:#0D1B3E; }

  /* HEADER */
  .ajd-header { background:linear-gradient(135deg,#0D1B3E,#1A3A5E); border-radius:16px; padding:24px 28px; margin-bottom:20px; display:flex; align-items:flex-start; justify-content:space-between; flex-wrap:wrap; gap:16px; }
  .ajd-header-left h1 { font-family:'Cormorant Garamond',serif; font-size:28px; color:#fff; margin:0 0 6px; }
  .ajd-header-meta { display:flex; gap:16px; flex-wrap:wrap; align-items:center; margin-top:8px; }
  .ajd-header-meta-item { font-size:12px; color:rgba(255,255,255,0.5); }
  .ajd-header-meta-item strong { color:rgba(255,255,255,0.85); }
  .ajd-status-badge { display:inline-flex; align-items:center; gap:6px; padding:6px 16px; border-radius:20px; font-size:12px; font-weight:700; letter-spacing:0.04em; }

  /* LAYOUT */
  .ajd-layout { display:grid; grid-template-columns:1fr 380px; gap:20px; align-items:start; }
  @media(max-width:900px){ .ajd-layout { grid-template-columns:1fr; } }

  /* CARDS */
  .ajd-card { background:#fff; border:1px solid #E8E6DF; border-radius:14px; overflow:hidden; margin-bottom:16px; }
  .ajd-card-header { padding:14px 20px; background:#F8F7F4; border-bottom:1px solid #E8E6DF; display:flex; align-items:center; justify-content:space-between; gap:10px; }
  .ajd-card-title { font-size:13px; font-weight:700; color:#0D1B3E; letter-spacing:0.04em; display:flex; align-items:center; gap:8px; }
  .ajd-card-body { padding:20px; }
  .ajd-field { margin-bottom:14px; }
  .ajd-field:last-child { margin-bottom:0; }
  .ajd-field-label { font-size:10px; font-weight:600; color:#B8B5AB; letter-spacing:0.08em; margin-bottom:4px; }
  .ajd-field-value { font-size:13px; color:#0D1B3E; }
  .ajd-grid-2 { display:grid; grid-template-columns:1fr 1fr; gap:14px; }
  .ajd-grid-3 { display:grid; grid-template-columns:1fr 1fr 1fr; gap:14px; }
  @media(max-width:580px){ .ajd-grid-2,.ajd-grid-3 { grid-template-columns:1fr; } }

  /* TIMELINE */
  .ajd-timeline { list-style:none; padding:0; margin:0; }
  .ajd-timeline-item { display:flex; gap:12px; padding:10px 0; position:relative; }
  .ajd-timeline-item::before { content:''; position:absolute; left:7px; top:28px; bottom:-10px; width:2px; background:#E8E6DF; }
  .ajd-timeline-item:last-child::before { display:none; }
  .ajd-timeline-dot { width:16px; height:16px; border-radius:50%; flex-shrink:0; margin-top:2px; }
  .ajd-timeline-content { flex:1; }
  .ajd-timeline-status { font-size:12px; font-weight:600; color:#0D1B3E; }
  .ajd-timeline-meta { font-size:11px; color:#B8B5AB; margin-top:2px; }
  .ajd-timeline-note { font-size:11px; color:#7A7870; margin-top:4px; font-style:italic; }

  /* ACTIONS */
  .ajd-actions { display:flex; flex-direction:column; gap:8px; }
  .ajd-action-btn { width:100%; padding:12px 16px; border-radius:10px; font-size:13px; font-weight:600; cursor:pointer; border:none; font-family:inherit; transition:all 0.2s; display:flex; align-items:center; justify-content:center; gap:8px; }
  .ajd-action-btn:hover { transform:translateY(-1px); }
  .ajd-action-btn:disabled { opacity:0.5; cursor:not-allowed; transform:none; }
  .ajd-action-primary { background:linear-gradient(135deg,#0D1B3E,#1A3A5E); color:#C9A84C; }
  .ajd-action-success { background:linear-gradient(135deg,#1A4A2E,#2D7A4F); color:#fff; }
  .ajd-action-warning { background:linear-gradient(135deg,#8A5C00,#C9A84C); color:#0D1B3E; }
  .ajd-action-danger  { background:linear-gradient(135deg,#8B1A1A,#E24B4A); color:#fff; }
  .ajd-action-outline { background:#fff; color:#0D1B3E; border:1.5px solid #E8E6DF !important; }
  .ajd-action-outline:hover { border-color:#C9A84C !important; }

  /* PAYMENT CARD */
  .ajd-pay-row { display:flex; justify-content:space-between; align-items:center; padding:10px 0; border-bottom:1px solid #F0EEE8; }
  .ajd-pay-row:last-child { border-bottom:none; }
  .ajd-pay-label { font-size:12px; color:#7A7870; }
  .ajd-pay-value { font-size:14px; font-weight:600; color:#0D1B3E; font-family:'Cormorant Garamond',serif; }
  .ajd-pay-status { font-size:10px; font-weight:700; padding:3px 10px; border-radius:20px; }

  /* SCANBACKS */
  .ajd-scanback-item { display:flex; align-items:center; justify-content:space-between; padding:10px 0; border-bottom:1px solid #F0EEE8; gap:10px; }
  .ajd-scanback-item:last-child { border-bottom:none; }

  /* NOTARY CARD */
  .ajd-notary-card { background:linear-gradient(135deg,#F8F7F4,#F0EEE8); border-radius:10px; padding:14px 16px; }
  .ajd-notary-name { font-size:15px; font-weight:600; color:#0D1B3E; margin-bottom:4px; }
  .ajd-notary-meta { font-size:12px; color:#7A7870; }

  /* MODAL OVERLAY */
  .ajd-modal-overlay { position:fixed; inset:0; background:rgba(0,0,0,0.7); z-index:1000; display:flex; align-items:center; justify-content:center; padding:20px; }
  .ajd-modal { background:#fff; border-radius:16px; padding:28px; max-width:540px; width:100%; max-height:85vh; overflow-y:auto; box-shadow:0 20px 60px rgba(0,0,0,0.3); }
  .ajd-modal-title { font-family:'Cormorant Garamond',serif; font-size:22px; color:#0D1B3E; margin-bottom:4px; }
  .ajd-modal-sub { font-size:13px; color:#7A7870; margin-bottom:20px; }
`

// ── STATUS CONFIG ─────────────────────────────────────────────
const STATUS_CONFIG = {
  new:                  { label:'🔴 New',                  color:'#C0392B', bg:'#FDF2F2', dot:'#E24B4A' },
  awaiting_assignment:  { label:'🔍 Finding Notary',        color:'#8A5C00', bg:'#FDF6E3', dot:'#C9A84C' },
  pending_acceptance:   { label:'⏳ Notary Notified',       color:'#185FA5', bg:'#EBF4FF', dot:'#5BA5E5' },
  assigned:             { label:'📲 Notified — Awaiting Response',       color:'#1A4A6B', bg:'#E8F4FF', dot:'#2D7AB5' },
  accepted:             { label:'✋ Notary Accepted',       color:'#1A4A6B', bg:'#E8F4FF', dot:'#2D7AB5' },
  confirmed:            { label:'📅 Appt Confirmed',        color:'#4A1A6B', bg:'#F0E8FF', dot:'#8B5CF6' },
  on_the_way:           { label:'🚗 On the Way',           color:'#1A3A6B', bg:'#E8F0FF', dot:'#3B82F6' },
  arrived:              { label:'📍 Arrived On-Site',       color:'#1A3A6B', bg:'#E8F0FF', dot:'#3B82F6' },
  in_progress:          { label:'✍️ Signing In Progress',   color:'#1A3A6B', bg:'#E8F0FF', dot:'#3B82F6' },
  scanbacks_uploaded:   { label:'📄 Docs Uploaded',         color:'#1A4A3E', bg:'#E8F5F0', dot:'#2D7A6A' },
  completed:            { label:'🏆 Completed',             color:'#1A4A2E', bg:'#EAF5EE', dot:'#2D7A4F' },
  awaiting_review:      { label:'🔎 Awaiting Review',       color:'#6A3A9A', bg:'#F5F0FF', dot:'#8B5CF6' },
  client_approved:      { label:'✅ Client Approved',       color:'#1A4A2E', bg:'#EAF5EE', dot:'#2D7A4F' },
  payment_received:     { label:'💳 Payment Received',      color:'#1A3A5E', bg:'#EBF4FF', dot:'#0D1B3E' },
  notary_paid:          { label:'💰 Notary Paid',           color:'#1A4A2E', bg:'#EAF5EE', dot:'#2D7A4F' },
  paid:                 { label:'💰 Paid',                  color:'#1A4A2E', bg:'#EAF5EE', dot:'#2D7A4F' },
  closed:               { label:'🔒 Closed',                color:'#4A4840', bg:'#F8F7F4', dot:'#B8B5AB' },
  cancelled:            { label:'❌ Cancelled',             color:'#8B1A1A', bg:'#FDF2F2', dot:'#E24B4A' },
}

// Canonical milestone progress — identical sequence to the client tracker, so admin + client stay in sync
function MilestoneTracker({ status, jobType, scanBacksRequired }) {
  const isIndividual = jobType === 'individual' || scanBacksRequired === false
  const companySteps = [
    { key:'new',                label:'Order Received'     },
    { key:'assigned',           label:'Notary Notified'    },
    { key:'accepted',           label:'Notary Confirmed'   },
    { key:'arrived',            label:'Notary Arrived'     },
    { key:'completed',          label:'Signing Complete'   },
    { key:'scanbacks_uploaded', label:'Documents Uploaded' },
    { key:'client_approved',    label:'Final Review'       },
    { key:'closed',             label:'Order Complete'     },
  ]
  // 👤 Individual track — paid upfront, no scans / shipping / invoice. Only what they need.
  const individualSteps = [
    { key:'new',       label:'💳 Paid — Order Received' },
    { key:'assigned',  label:'Notary Assigned'         },
    { key:'accepted',  label:'Notary Confirmed'        },
    { key:'arrived',   label:'Notary Arrived'          },
    { key:'completed', label:'Signing Complete'        },
    { key:'closed',    label:'Order Complete'          },
  ]
  const displaySteps = isIndividual ? individualSteps : companySteps
  const STEP_FOR_STATUS = isIndividual ? {
    new:'new', awaiting_assignment:'new',
    assigned:'assigned', declined:'assigned',
    accepted:'accepted', on_the_way:'accepted',
    arrived:'arrived', completed:'completed',
    scanbacks_uploaded:'completed', client_approved:'completed',
    payment_received:'closed', notary_paid:'closed', closed:'closed',
  } : {
    new:'new', awaiting_assignment:'new',
    assigned:'assigned', declined:'assigned',
    accepted:'accepted', on_the_way:'accepted',
    arrived:'arrived', completed:'completed',
    scanbacks_uploaded:'scanbacks_uploaded',
    client_approved:'client_approved', payment_received:'closed', notary_paid:'closed', closed:'closed',
  }
  if (status === 'cancelled') return null
  const currentColor = isIndividual ? '#6A3A9A' : '#C9A84C'
  const idx = displaySteps.findIndex(s => s.key === (STEP_FOR_STATUS[status] || 'new'))
  return (
    <div style={{ marginBottom:16 }}>
      {isIndividual && (
        <div style={{ display:'inline-block', background:'#F0E8FF', color:'#6A3A9A', fontSize:10, fontWeight:700, padding:'3px 10px', borderRadius:20, marginBottom:12 }}>👤 INDIVIDUAL ORDER — paid upfront</div>
      )}
      {displaySteps.map((s, i) => {
        const done = i < idx, current = i === idx
        return (
          <div key={s.key} style={{ display:'flex', alignItems:'center', gap:10, marginBottom: i < displaySteps.length-1 ? 8 : 0 }}>
            <div style={{ width:22, height:22, borderRadius:'50%', flexShrink:0, display:'flex', alignItems:'center', justifyContent:'center', fontSize:11, fontWeight:700, background: done?'#2D7A4F':current?currentColor:'#E8E6DF', color: done||current?'#fff':'#B8B5AB' }}>{done ? '✓' : i+1}</div>
            <span style={{ fontSize:13, color: current?'#0D1B3E':done?'#2D7A4F':'#B8B5AB', fontWeight: current?700:500 }}>{s.label}{current && <span style={{ fontSize:10, color:currentColor, marginLeft:8 }}>← Current</span>}</span>
          </div>
        )
      })}
    </div>
  )
}

function StatusBadge({ status }) {
  const cfg = STATUS_CONFIG[status] || { label: status, color:'#7A7870', bg:'#F8F7F4' }
  return (
    <span className="ajd-status-badge" style={{ background:cfg.bg, color:cfg.color }}>
      {cfg.label}
    </span>
  )
}

// ── LOG STATUS EVENT ──────────────────────────────────────────
async function logStatusEvent(jobId, status, role = 'admin', note = null) {
  const { data: { user } } = await supabase.auth.getUser()
  await supabase.from('job_status_events').insert({
    job_id:          jobId,
    status,
    created_by_role: role,
    created_by:      user?.id || null,
    note,
  })
}

// ── ASSIGN NOTARY MODAL ───────────────────────────────────────
function AssignNotaryModal({ job, onClose, onAssigned }) {
  const [allNotaries,   setAllNotaries]   = useState([])
  const [notaries,      setNotaries]      = useState([])
  const [selected,      setSelected]      = useState('')
  const [loading,       setLoading]       = useState(true)
  const [saving,        setSaving]        = useState(false)
  const [showAllStates, setShowAllStates] = useState(false)

  useEffect(() => {
    supabase.from('profiles').select('*, notaries(*)')
      .eq('role', 'notary').eq('is_approved', true)
      .then(({ data }) => {
        const sorted = (data || []).sort((a, b) =>
          (b.notaries?.priority_score || 0) - (a.notaries?.priority_score || 0))
        setAllNotaries(sorted)
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    if (showAllStates) {
      setNotaries(allNotaries)
    } else {
      const jobState = job.signing_state?.toUpperCase().trim()
      setNotaries(allNotaries.filter(n =>
        n.notaries?.commission_state?.toUpperCase().trim() === jobState
      ))
    }
  }, [allNotaries, showAllStates, job.signing_state])

  async function assign() {
    if (!selected) return toast.error('Please select a notary first')
    setSaving(true)
    try {
      const notary = notaries.find(n => n.id === selected)
      // 🔄 Detect reassignment vs first assignment
      const isReassignment = job.notary_id && job.notary_id !== selected
      const previousNotaryId = job.notary_id
      const eventNote = isReassignment
        ? `🔄 REASSIGNED to ${notary?.full_name} (previous notary unassigned)`
        : `✅ Assigned to ${notary?.full_name}`
      const { error } = await supabase.from('jobs').update({ notary_id: selected, status: 'assigned' }).eq('id', job.id)
      if (error) throw error
      await logStatusEvent(job.id, 'assigned', 'admin', eventNote)
      // 📊 Track offer for metrics
      try { await trackOffer(selected, job.id) } catch(e) { console.error('Metrics error:', e) }
      // 🔔 Notify the notary — fire BOTH channels in PARALLEL so the instant SMS
      // never waits behind the (slower) email, and a phone-only notary still gets a text.
      const addressStr = `${job.signing_address}, ${job.signing_city}, ${job.signing_state}`
      const apptStr    = job.scheduled_at ? new Date(job.scheduled_at).toLocaleString() : null
      const notifications = []
      if (notary?.email) {
        notifications.push(sendNotaryAssignment({
          notary_name:   notary.full_name,
          notary_email:  notary.email,
          job_number:    job.job_number,
          service_name:  job.signing_type,
          address:       addressStr,
          appointment:   apptStr,
          pay:           job.notary_pay,
          special_notes: job.special_instructions,
        }))
      }
      if (notary?.phone) {
        notifications.push(smsNotaryAssignment({
          notary_name: notary.full_name, notary_phone: notary.phone,
          job_number: job.job_number, service_name: job.signing_type,
          address: addressStr, appointment: apptStr, pay: job.notary_pay,
        }))
      }
      await Promise.allSettled(notifications)
      // 🔔 Client is intentionally NOT notified here — the "your notary is confirmed"
      // message fires when the notary ACCEPTS (NotaryPortal acceptJob), so a decline +
      // reassignment never shows the client a notary name that then changes.
      toast.success(`✅ ${notary?.full_name} notified — awaiting acceptance for ${job.job_number}!!`)
      onAssigned()
      onClose()
    } catch(err) { toast.error(err.message) }
    finally { setSaving(false) }
  }

  return (
    <div className="ajd-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="ajd-modal" role="dialog" aria-modal="true">
        <div className="ajd-modal-title">Assign a Notary</div>
        <div className="ajd-modal-sub">Select an approved notary — they will be notified immediately!!</div>

        {/* Job summary */}
        <div style={{ background:'#F8F7F4', borderRadius:10, padding:'14px 16px', marginBottom:20, fontSize:13 }}>
          {[['Job #', job.job_number], ['Service', job.signing_type], ['Borrower', job.borrower_name],
            ['Location', `${job.signing_city}, ${job.signing_state}`],
            ['Date', job.scheduled_at ? new Date(job.scheduled_at).toLocaleString() : 'Flexible'],
            ['Notary Pay', `$${job.notary_pay}`]
          ].map(([l, v]) => (
            <div key={l} style={{ display:'flex', justifyContent:'space-between', padding:'3px 0', color:'#4A4840' }}>
              <span style={{ color:'#7A7870' }}>{l}</span><strong>{v}</strong>
            </div>
          ))}
        </div>

        {/* State filter */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:10, flexWrap:'wrap', gap:8 }}>
          <div style={{ fontSize:12, fontWeight:500, color:'#7A7870' }}>
            {notaries.length} NOTARIES {showAllStates ? '(ALL STATES)' : `IN ${job.signing_state || 'THIS STATE'}`}
          </div>
          <label style={{ display:'flex', alignItems:'center', gap:6, fontSize:11, color:'#7A7870', cursor:'pointer' }}>
            <input type="checkbox" checked={showAllStates} onChange={e => setShowAllStates(e.target.checked)} />
            Show all states
          </label>
        </div>

        {/* Notary list */}
        {loading && <div style={{ textAlign:'center', padding:24, color:'#B8B5AB' }}>Loading notaries...</div>}
        {!loading && notaries.length === 0 && (
          <div style={{ textAlign:'center', padding:24, color:'#B8B5AB', fontSize:13 }}>
            No approved notaries in <strong>{job.signing_state}</strong> — toggle above for all states!!
          </div>
        )}
        <div style={{ display:'flex', flexDirection:'column', gap:8, marginBottom:20, maxHeight:280, overflowY:'auto' }}>
          {notaries.map(n => (
            <div key={n.id}
              onClick={() => setSelected(n.id)}
              style={{ display:'flex', alignItems:'center', gap:12, padding:'12px 14px', borderRadius:10, cursor:'pointer', border:`1.5px solid ${selected===n.id ? '#C9A84C' : '#E8E6DF'}`, background: selected===n.id ? '#FDF6E3' : '#fff', transition:'all 0.15s' }}>
              <div style={{ width:36, height:36, borderRadius:'50%', background:'#0D1B3E', display:'flex', alignItems:'center', justifyContent:'center', fontSize:13, fontWeight:500, color:'#C9A84C', flexShrink:0 }}>
                {n.full_name?.charAt(0) || '?'}
              </div>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:13, fontWeight:500, color:'#0D1B3E' }}>{n.full_name}</div>
                <div style={{ fontSize:11, color:'#7A7870', marginTop:2 }}>
                  {n.notaries?.commission_state || '—'} · {n.notaries?.total_signings || 0} signings · ⭐ {n.notaries?.avg_rating || '—'}
                </div>
              </div>
              {selected === n.id && <div style={{ color:'#C9A84C', fontSize:18 }}>✓</div>}
            </div>
          ))}
        </div>

        <div style={{ display:'flex', gap:10 }}>
          <button className="btn btn-outline" onClick={onClose} disabled={saving}>Cancel</button>
          <button className="btn btn-primary" onClick={assign} disabled={!selected || saving} style={{ flex:1 }}>
            {saving ? 'Assigning...' : 'Assign & Notify →'}
          </button>
        </div>
      </div>
    </div>
  )
}

// ── BLAST NOTARIES MODAL — Mass notify qualified notaries (first-accept wins) ──
function BlastNotariesModal({ job, onClose, onBlasted }) {
  const [allNotaries, setAllNotaries] = useState([])
  const [filteredNotaries, setFilteredNotaries] = useState([])
  const [loading, setLoading] = useState(true)
  const [sending, setSending] = useState(false)
  const [stateFilter, setStateFilter] = useState(job.signing_state?.toUpperCase().trim() || 'ALL')
  const [vettedOnly, setVettedOnly] = useState(true)
  const [ronOnly, setRonOnly] = useState(false)

  useEffect(() => {
    supabase.from('profiles').select('*, notaries(*)')
      .eq('role', 'notary').eq('is_approved', true)
      .then(({ data }) => {
        // Only include notaries who are READY TO WORK
        const ready = (data || []).filter(n => n.notaries?.ready_to_work === true)
        setAllNotaries(ready)
        setLoading(false)
      })
  }, [])

  useEffect(() => {
    let list = allNotaries
    if (stateFilter !== 'ALL') {
      list = list.filter(n => n.notaries?.commission_state?.toUpperCase().trim() === stateFilter)
    }
    if (vettedOnly) {
      list = list.filter(n => n.notaries?.is_vetted)
    }
    if (ronOnly) {
      list = list.filter(n => n.notaries?.is_ron)
    }
    setFilteredNotaries(list)
  }, [allNotaries, stateFilter, vettedOnly, ronOnly])

  async function sendBlast() {
    if (filteredNotaries.length === 0) {
      toast.error('No qualified notaries match the filters!!')
      return
    }
    if (!window.confirm(`Send BLAST to ${filteredNotaries.length} qualified notaries??\n\nFirst notary to accept will be assigned. All others will be politely notified the job was claimed.\n\nProceed??`)) return

    setSending(true)
    try {
      // 1. Mark job as blast_active
      await supabase.from('jobs').update({
        blast_active: true,
        blast_started_at: new Date().toISOString(),
        blast_recipient_count: filteredNotaries.length,
        status: 'awaiting_assignment',
      }).eq('id', job.id)

      // 2. Insert recipient records
      const recipients = filteredNotaries.map(n => ({
        job_id: job.id,
        notary_id: n.id,
        outcome: 'pending',
      }))
      await supabase.from('job_blast_recipients').insert(recipients)

      // 3. Send email + SMS to each
      const emailPromises = filteredNotaries.map(async (n) => {
        try {
          if (n.email) {
            await sendBlastInvite({
              notary_name: n.full_name,
              notary_email: n.email,
              job_number: job.job_number,
              service_name: job.signing_type,
              address: `${job.signing_city}, ${job.signing_state}`,
              appointment: job.scheduled_at ? new Date(job.scheduled_at).toLocaleString() : 'TBD',
              pay: job.notary_pay,
            })
          }
        } catch(e) { console.error('Blast email error for', n.full_name, e) }
      })
      await Promise.all(emailPromises)

      // 4. Log status event
      await logStatusEvent(job.id, 'awaiting_assignment', 'admin', `📢 BLASTED to ${filteredNotaries.length} qualified notaries (first-accept wins)`)

      // 📊 Track offer for each recipient
      try {
        await Promise.all(filteredNotaries.map(n => trackOffer(n.id, job.id)))
      } catch(e) { console.error('Blast metrics error:', e) }

      toast.success(`📢 BLAST sent to ${filteredNotaries.length} notaries!!`)
      onBlasted()
    } catch(err) {
      toast.error(err.message)
    } finally {
      setSending(false)
    }
  }

  return (
    <div className="ajd-modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="ajd-modal" role="dialog" aria-modal="true">
        <div className="ajd-modal-title">📢 Blast to Qualified Notaries</div>
        <div className="ajd-modal-sub">First notary to accept wins the job — all others will be notified.</div>

        <div style={{ background:'#F8F7F4', borderRadius:10, padding:'14px 16px', marginBottom:20, fontSize:13 }}>
          {[['Job #', job.job_number], ['Service', job.signing_type],
            ['Location', `${job.signing_city}, ${job.signing_state}`],
            ['Notary Pay', `$${job.notary_pay}`]
          ].map(([l, v]) => (
            <div key={l} style={{ display:'flex', justifyContent:'space-between', padding:'3px 0', color:'#4A4840' }}>
              <span style={{ color:'#7A7870' }}>{l}</span><strong>{v}</strong>
            </div>
          ))}
        </div>

        {/* Filters */}
        <div style={{ marginBottom:16 }}>
          <div style={{ fontSize:11, fontWeight:700, color:'#7A7870', marginBottom:8, letterSpacing:'0.06em' }}>FILTERS</div>
          <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:10, marginBottom:10 }}>
            <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, cursor:'pointer' }}>
              <input type="checkbox" checked={stateFilter !== 'ALL'} onChange={e => setStateFilter(e.target.checked ? (job.signing_state?.toUpperCase().trim() || 'ALL') : 'ALL')} />
              Job state only ({job.signing_state})
            </label>
            <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, cursor:'pointer' }}>
              <input type="checkbox" checked={vettedOnly} onChange={e => setVettedOnly(e.target.checked)} />
              Vetted notaries only
            </label>
            <label style={{ display:'flex', alignItems:'center', gap:8, fontSize:13, cursor:'pointer' }}>
              <input type="checkbox" checked={ronOnly} onChange={e => setRonOnly(e.target.checked)} />
              RON certified only
            </label>
          </div>
        </div>

        {/* Recipient count */}
        <div style={{ background:'linear-gradient(135deg,#0D1B3E,#1A3A5E)', borderRadius:10, padding:'14px 18px', marginBottom:20, color:'#fff', textAlign:'center' }}>
          {loading ? (
            <div style={{ fontSize:13, color:'rgba(255,255,255,0.6)' }}>Loading notaries...</div>
          ) : (
            <>
              <div style={{ fontSize:32, fontWeight:700, color:'#C9A84C', lineHeight:1 }}>{filteredNotaries.length}</div>
              <div style={{ fontSize:11, color:'rgba(255,255,255,0.6)', marginTop:4, letterSpacing:'0.1em' }}>QUALIFIED NOTARIES WILL BE NOTIFIED</div>
            </>
          )}
        </div>

        <div style={{ display:'flex', gap:10 }}>
          <button onClick={onClose} className="btn btn-outline" disabled={sending} style={{ flex:1 }}>Cancel</button>
          <button
            onClick={sendBlast}
            disabled={sending || filteredNotaries.length === 0}
            style={{
              flex:2,
              background: sending || filteredNotaries.length === 0 ? '#E8E6DF' : 'linear-gradient(135deg,#8A5C00,#C9A84C)',
              color: sending || filteredNotaries.length === 0 ? '#B8B5AB' : '#fff',
              border:'none', borderRadius:8, padding:'12px 16px', fontSize:14, fontWeight:700, cursor: sending ? 'not-allowed' : 'pointer'
            }}
          >
            {sending ? 'Sending Blast...' : `📢 Send Blast to ${filteredNotaries.length} Notaries →`}
          </button>
        </div>
      </div>
    </div>
  )
}

// ── MESSAGES WITH TABS — avoids duplicate realtime channel collision ──
function MessagesWithTabs({ jobId, jobNumber, hasClient }) {
  const [tab, setTab] = useState('notary')
  return (
    <>
      {hasClient && (
        <div style={{ display:'flex', gap:8, marginTop:16, marginBottom:12 }}>
          {[['notary','↔ Notary'],['client','↔ Client']].map(([val, label]) => (
            <button key={val} onClick={() => setTab(val)}
              style={{ padding:'6px 16px', borderRadius:20, border:'1.5px solid', fontSize:11, fontWeight:600, cursor:'pointer', fontFamily:'inherit',
                background: tab===val ? '#0D1B3E' : '#fff',
                color:      tab===val ? '#C9A84C' : '#7A7870',
                borderColor:tab===val ? '#0D1B3E' : '#E8E6DF' }}>
              Admin {label}
            </button>
          ))}
        </div>
      )}
      {/* Only ONE JobMessages mounted at a time — prevents channel collision!! */}
      {tab === 'notary' && (
        <JobMessages jobId={jobId} jobNumber={jobNumber} role="admin" recipientRole="notary" />
      )}
      {tab === 'client' && hasClient && (
        <JobMessages jobId={jobId} jobNumber={jobNumber} role="admin" recipientRole="client" />
      )}
    </>
  )
}

// ── MAIN COMPONENT ────────────────────────────────────────────
export default function AdminJobDetail() {
  const { jobId }   = useParams()
  const navigate    = useNavigate()
  const [job,       setJob]       = useState(null)
  const [notary,    setNotary]    = useState(null)
  const [client,    setClient]    = useState(null)
  const [timeline,  setTimeline]  = useState([])
  const [scanbacks, setScanbacks] = useState([])
  const [docs,      setDocs]      = useState([])
  const [payments,  setPayments]  = useState(null)
  const [shipping,  setShipping]  = useState(null)
  const [loading,   setLoading]   = useState(true)
  const [saving,    setSaving]    = useState(false)
  const [showAssign,setShowAssign]= useState(false)
  const [showBlast, setShowBlast] = useState(false)

  // Shipping form state
  const [carrier,   setCarrier]   = useState('')
  const [tracking,  setTracking]  = useState('')
  const [dropoff,   setDropoff]   = useState('')
  const [savingShip,setSavingShip]= useState(false)

  // Payment form state
  const [invoiceAmt,    setInvoiceAmt]    = useState('')
  const [notaryPayAmt,  setNotaryPayAmt]  = useState('')
  const [savingPay,     setSavingPay]     = useState(false)

  const loadJob = useCallback(async () => {
    if (!jobId) return
    const { data: jobData } = await supabase.from('jobs').select('*').eq('id', jobId).single()
    if (!jobData) { toast.error('Job not found!!'); navigate('/admin/jobs'); return }
    setJob(jobData)

    // Load notary profile
    if (jobData.notary_id) {
      const { data: p } = await supabase.from('profiles').select('*, notaries(*)').eq('id', jobData.notary_id).single()
      setNotary(p)
    } else {
      setNotary(null)
    }

    // Load client profile
    if (jobData.client_id) {
      const { data: c } = await supabase.from('profiles').select('*').eq('id', jobData.client_id).single()
      setClient(c)
    }

    // Load timeline
    const { data: tl } = await supabase.from('job_status_events')
      .select('*').eq('job_id', jobId).order('created_at', { ascending: true })
    setTimeline(tl || [])

    // Load documents
    const { data: d } = await supabase.from('job_documents')
      .select('*').eq('job_id', jobId).order('created_at', { ascending: false })
    const allDocs = d || []
    setDocs(allDocs.filter(x => x.doc_type !== 'scan_back' && x.doc_type !== 'completed_docs'))
    setScanbacks(allDocs.filter(x => x.doc_type === 'scan_back' || x.doc_type === 'completed_docs'))

    // Load payments - use maybeSingle() to avoid 406 when no row exists
    const { data: pay } = await supabase.from('job_payments')
      .select('*').eq('job_id', jobId).maybeSingle()
    if (pay) {
      setPayments(pay)
      setInvoiceAmt(pay.client_invoice_amount || '')
      setNotaryPayAmt(pay.notary_pay_amount || '')
    } else {
      setInvoiceAmt(jobData.total_fee || '')
      setNotaryPayAmt(jobData.notary_pay || '')
    }

    // Load shipping — read from the JOB record (the single source of truth shared with
    // the notary app + client portal). job_shipping is only used for the extra drop-off date.
    const { data: ship } = await supabase.from('job_shipping')
      .select('*').eq('job_id', jobId).maybeSingle()
    setShipping({
      carrier:         jobData.shipping_carrier || ship?.carrier || '',
      tracking_number: jobData.tracking_number  || ship?.tracking_number || '',
      dropoff_date:    ship?.dropoff_date || '',
      shipped_at:      jobData.shipped_at || null,
    })
    setCarrier(jobData.shipping_carrier || ship?.carrier || '')
    setTracking(jobData.tracking_number || ship?.tracking_number || '')
    // 🕒 Drop-off auto-stamps from the moment the notary submitted tracking (shipped_at).
    // Admin never has to type it; falls back to a manual job_shipping date if present.
    setDropoff(jobData.shipped_at ? jobData.shipped_at.slice(0, 10) : (ship?.dropoff_date || ''))

    setLoading(false)
  }, [jobId, navigate])

  useEffect(() => { loadJob() }, [loadJob])

  // ── 🔄 REAL-TIME SUBSCRIPTIONS — Admin sees ALL updates instantly!! ──
  useEffect(() => {
    if (!jobId) return

    // Subscribe to job updates (status changes, scanback uploads, tracking #, etc.)
    const jobCh = supabase.channel(`admin-job-detail-${jobId}`)
      .on('postgres_changes', {
        event:  'UPDATE',
        schema: 'public',
        table:  'jobs',
        filter: `id=eq.${jobId}`,
      }, () => {
        loadJob()
      })
      .subscribe()

    // Subscribe to NEW documents (notary uploaded scanback, client uploaded package)
    const docsCh = supabase.channel(`admin-job-docs-${jobId}`)
      .on('postgres_changes', {
        event:  'INSERT',
        schema: 'public',
        table:  'job_documents',
        filter: `job_id=eq.${jobId}`,
      }, payload => {
        loadJob()
        const docType = payload.new?.doc_type
        if (docType === 'scan_back' || docType === 'completed_docs') {
          toast.success('📄 Notary uploaded a scan-back!!', { duration: 5000 })
        } else if (docType === 'signing_package') {
          toast.success('📦 Client uploaded the closing package!!', { duration: 5000 })
        }
      })
      .subscribe()

    return () => {
      supabase.removeChannel(jobCh)
      supabase.removeChannel(docsCh)
    }
  }, [jobId, loadJob])

  // ── UPDATE STATUS ──────────────────────────────────────────
  async function updateStatus(newStatus, note = null) {
    setSaving(true)
    try {
      await supabase.from('jobs').update({ status: newStatus }).eq('id', jobId)
      await logStatusEvent(jobId, newStatus, 'admin', note)

      // Notifications
      if (job.borrower_email) {
        await sendStatusUpdate({
          client_name:  job.borrower_name,
          client_email: job.borrower_email,
          job_number:   job.job_number,
          service_name: job.signing_type,
          new_status:   newStatus,
          notary_name:  notary?.full_name || null,
          appointment:  job.scheduled_at ? new Date(job.scheduled_at).toLocaleString() : null,
        })
      }

      if (newStatus === 'completed' && job.borrower_email) {
        await sendJobCompleted({
          client_name:  job.borrower_name,
          client_email: job.borrower_email,
          job_number:   job.job_number,
          service_name: job.signing_type,
          amount:       job.total_fee,
        })
      }

      toast.success(`✅ Job updated to: ${newStatus}!!`)
      await loadJob()
    } catch(err) { toast.error(err.message) }
    finally { setSaving(false) }
  }

  // ── APPROVE SCANBACK ───────────────────────────────────────
  async function approveScanback(docId) {
    await supabase.from('job_documents').update({
      qc_status: 'approved', qc_approved_at: new Date().toISOString(),
    }).eq('id', docId)
    await supabase.from('jobs').update({ title_qc_status: 'approved' }).eq('id', jobId)
    toast.success('✅ Scan-back approved!! Notary can now ship documents!!')
    loadJob()
  }

  async function rejectScanback(docId, reason) {
    if (!reason) { toast.error('Please enter a rejection reason!!'); return }
    await supabase.from('job_documents').update({
      qc_status: 'rejected', qc_correction_notes: reason,
    }).eq('id', docId)
    toast.success('Scan-back rejected — notary has been notified!!')
    loadJob()
  }

  // ── SAVE SHIPPING ──────────────────────────────────────────
  async function saveShipping() {
    if (!carrier || !tracking) { toast.error('Please enter carrier and tracking number!!'); return }
    setSavingShip(true)
    try {
      if (shipping?.id) {
        await supabase.from('job_shipping').update({
          carrier, tracking_number: tracking, dropoff_date: dropoff || null,
        }).eq('id', shipping.id)
      } else {
        await supabase.from('job_shipping').insert({
          job_id: jobId, carrier, tracking_number: tracking, dropoff_date: dropoff || null,
        })
      }
      await supabase.from('jobs').update({ tracking_number: tracking, shipping_carrier: carrier }).eq('id', jobId)
      await logStatusEvent(jobId, 'package_shipped', 'admin', `${carrier} tracking: ${tracking}`)
      toast.success('✅ Shipping info saved!!')
      loadJob()
    } catch(err) { toast.error(err.message) }
    finally { setSavingShip(false) }
  }

  // ── SAVE PAYMENTS ──────────────────────────────────────────
  async function savePayments() {
    if (!invoiceAmt) { toast.error('Please enter the invoice amount!!'); return }
    setSavingPay(true)
    try {
      const payload = {
        job_id:                jobId,
        client_invoice_amount: Number(invoiceAmt),
        notary_pay_amount:     Number(notaryPayAmt) || 0,
        updated_at:            new Date().toISOString(),
      }
      if (payments?.id) {
        await supabase.from('job_payments').update(payload).eq('id', payments.id)
      } else {
        await supabase.from('job_payments').insert(payload)
      }
      // 🔗 Keep the JOB record in sync, too — the header banner and the notary's own
      // portal both read jobs.notary_pay / total_fee / lca_cut. Without this they show $0.
      await supabase.from('jobs').update({
        total_fee:  Number(invoiceAmt),
        notary_pay: Number(notaryPayAmt) || 0,
        lca_cut:    Number(invoiceAmt) - (Number(notaryPayAmt) || 0),
      }).eq('id', jobId)
      toast.success('✅ Payment info saved!!')
      loadJob()
    } catch(err) { toast.error(err.message) }
    finally { setSavingPay(false) }
  }

  // ── SEND INVOICE TO CLIENT ─────────────────────────────────
  async function sendInvoice() {
    if (!invoiceAmt) { toast.error('Please enter & save the invoice amount first!!'); return }
    setSaving(true)
    try {
      await supabase.from('jobs').update({
        invoice_sent_at: new Date().toISOString(),
        total_fee:       Number(invoiceAmt),
      }).eq('id', jobId)
      toast.success('📧 Invoice sent!! It now shows in the client\u2019s Invoices.')
      loadJob()
    } catch(err) { toast.error(err.message) }
    finally { setSaving(false) }
  }

  // ── MARK CLIENT PAID ───────────────────────────────────────
  async function markClientPaid() {
    if (!payments?.id) { toast.error('Please save payment amounts first!!'); return }
    setSaving(true)
    try {
      await supabase.from('job_payments').update({
        client_payment_status: 'paid',
        client_payment_date:   new Date().toISOString(),
      }).eq('id', payments.id)
      // 🔗 Sync the JOB record — the client's Invoices page reads jobs.client_paid_at
      await supabase.from('jobs').update({ client_paid_at: new Date().toISOString() }).eq('id', jobId)
      await updateStatus('payment_received', 'Client payment received')
      toast.success('✅ Client payment recorded!!')
    } catch(err) { toast.error(err.message) }
    finally { setSaving(false) }
  }

  // ── RELEASE NOTARY PAYMENT ─────────────────────────────────
  async function releaseNotaryPayment() {
    if (!payments?.id) { toast.error('Please save payment amounts first!!'); return }

    // ✅ Tuesday 5pm EST → Friday payout logic
    const now      = new Date()
    const day      = now.getDay() // 0=Sun, 2=Tue, 5=Fri
    const hour     = now.getUTCHours() - 5 // EST offset
    let   payDate  = new Date(now)

    if (day < 2 || (day === 2 && hour < 17)) {
      // Before Tuesday 5pm → pay this Friday
      const daysUntilFriday = (5 - day + 7) % 7 || 7
      payDate.setDate(now.getDate() + daysUntilFriday)
    } else {
      // After Tuesday 5pm → pay NEXT Friday
      const daysUntilNextFriday = (5 - day + 7) % 7 || 7
      if (daysUntilNextFriday === 0) payDate.setDate(now.getDate() + 7)
      else payDate.setDate(now.getDate() + daysUntilNextFriday + 7)
    }

    setSaving(true)
    try {
      await supabase.from('job_payments').update({
        notary_payment_status: 'scheduled',
        notary_payment_date:   payDate.toISOString(),
        auto_release_eligible: true,
      }).eq('id', payments.id)
      await logStatusEvent(jobId, 'notary_payment_scheduled', 'admin', `Scheduled for ${payDate.toLocaleDateString()}`)

      if (notary?.email) {
        await sendPaymentSent({
          notary_name:  notary.full_name,
          notary_email: notary.email,
          amount:       payments.notary_pay_amount,
          job_number:   job.job_number,
          pay_date:     payDate.toLocaleDateString(),
        })
      }
      toast.success(`✅ Notary payment scheduled for ${payDate.toLocaleDateString()}!!`)
      loadJob()
    } catch(err) { toast.error(err.message) }
    finally { setSaving(false) }
  }

  // ── MARK NOTARY PAID ───────────────────────────────────────
  async function markNotaryPaid() {
    if (!payments?.id) { toast.error('Please save payment amounts first!!'); return }

    // 🛡️ DATA INTEGRITY GATE — Can't pay notary if no notary assigned!!
    if (!job.notary_id) {
      toast.error('🛡️ Cannot mark notary paid — no notary is assigned to this job!!', { duration: 6000 })
      return
    }

    // 💰 LINEAR PAYMENT FLOW WARNING — Client should pay BEFORE notary!!
    if (payments?.client_payment_status !== 'paid') {
      const proceed = window.confirm(
        '⚠️ The CLIENT has not paid yet!!\n\n' +
        'Most agencies wait for client payment to protect cash flow.\n' +
        'Paying the notary first means LCA is acting as a bank.\n\n' +
        'Click OK to pay notary anyway, or Cancel to wait for client payment first.'
      )
      if (!proceed) return
    }

    setSaving(true)
    try {
      const paidDate = new Date()
      await supabase.from('job_payments').update({
        notary_payment_status: 'paid',
        notary_payment_date:   paidDate.toISOString(),
      }).eq('id', payments.id)
      await updateStatus('notary_paid', 'Notary payment sent')

      // 📧 Send actual PAID confirmation email to notary
      if (notary?.email) {
        try {
          await sendPaymentSent({
            notary_name:  notary.full_name,
            notary_email: notary.email,
            amount:       payments.notary_pay_amount,
            job_number:   job.job_number,
            pay_date:     paidDate.toLocaleDateString(),
          })
        } catch(emailErr) {
          console.error('Payment confirmation email error:', emailErr)
        }
      }
      toast.success(`💰 Notary payment marked PAID — confirmation email sent!!`)
    } catch(err) { toast.error(err.message) }
    finally { setSaving(false) }
  }

  // ── RENDER ─────────────────────────────────────────────────
  if (loading) return (
    <div style={{ display:'flex', alignItems:'center', justifyContent:'center', padding:80 }}>
      <div className="spinner" />
    </div>
  )

  if (!job) return null

  const cfg = STATUS_CONFIG[job.status] || { label: job.status, color:'#7A7870', bg:'#F8F7F4', dot:'#B8B5AB' }

  return (
    <>
      <style>{STYLES}</style>
      {showAssign && (
        <AssignNotaryModal
          job={job}
          onClose={() => setShowAssign(false)}
          onAssigned={() => { setShowAssign(false); loadJob() }}
        />
      )}
      {showBlast && (
        <BlastNotariesModal
          job={job}
          onClose={() => setShowBlast(false)}
          onBlasted={() => { setShowBlast(false); loadJob() }}
        />
      )}

      <div className="ajd-wrap">

        {/* BACK BUTTON */}
        <button className="ajd-back" onClick={() => navigate('/admin/jobs')}>
          ← Back to All Jobs
        </button>

        {/* ── HEADER ── */}
        <div className="ajd-header">
          <div className="ajd-header-left">
            <h1>Job #{job.job_number}</h1>
            <StatusBadge status={job.status} />
            {(job.job_type === 'individual' || job.scan_backs_required === false) && (
              <span style={{ background:'#F0E8FF', color:'#6A3A9A', fontSize:11, fontWeight:700, padding:'3px 10px', borderRadius:20, marginLeft:8 }}>👤 INDIVIDUAL</span>
            )}
            <div className="ajd-header-meta">
              <div className="ajd-header-meta-item"><strong>{job.signing_type}</strong></div>
              <div className="ajd-header-meta-item">{(job.job_type === 'individual' || job.scan_backs_required === false) ? 'Customer' : 'Borrower'}: <strong>{job.borrower_name}</strong></div>
              {job.job_type !== 'individual' && job.scan_backs_required !== false && (
                <div className="ajd-header-meta-item">
                  {client ? <>Client: <strong>{client.full_name || client.email}</strong></> : null}
                </div>
              )}
              <div className="ajd-header-meta-item">
                Created: <strong>{new Date(job.created_at).toLocaleString()}</strong>
              </div>
              {job.is_veteran && (
                <span style={{ background:'rgba(201,168,76,0.2)', color:'#C9A84C', fontSize:11, fontWeight:700, padding:'3px 10px', borderRadius:20 }}>
                  🎖️ VETERAN
                </span>
              )}
              {job.client_closed_at && (
                <span title={`Closed by client on ${new Date(job.client_closed_at).toLocaleString()}`} style={{ background:'rgba(45,122,79,0.15)', color:'#2D7A4F', fontSize:11, fontWeight:700, padding:'3px 10px', borderRadius:20 }}>
                  🏁 CLIENT CLOSED — AWAITING PAYMENT
                </span>
              )}
            </div>
          </div>
          <div style={{ textAlign:'right' }}>
            <div style={{ fontFamily:'Cormorant Garamond,serif', fontSize:32, color:'#C9A84C', fontWeight:600 }}>
              ${job.total_fee}
            </div>
            <div style={{ fontSize:11, color:'rgba(255,255,255,0.4)', marginTop:2 }}>Total Fee</div>
            <div style={{ fontSize:13, color:'rgba(255,255,255,0.6)', marginTop:4 }}>
              LCA: <strong style={{ color:'#C9A84C' }}>${job.lca_cut || 25}</strong> &nbsp;·&nbsp;
              Notary: <strong style={{ color:'#5BA882' }}>${job.notary_pay || 0}</strong>
            </div>
          </div>
        </div>

        {/* ── TWO COLUMN LAYOUT ── */}
        <div className="ajd-layout">

          {/* ── LEFT COLUMN ── */}
          <div>

            {/* APPOINTMENT CARD */}
            <div className="ajd-card">
              <div className="ajd-card-header">
                <div className="ajd-card-title">📅 Appointment Details</div>
              </div>
              <div className="ajd-card-body">
                <div className="ajd-grid-2">
                  <div className="ajd-field">
                    <div className="ajd-field-label">DATE & TIME</div>
                    <div className="ajd-field-value">
                      {job.scheduled_at ? new Date(job.scheduled_at).toLocaleString() : <span style={{ color:'#B8B5AB' }}>Flexible — TBD</span>}
                    </div>
                  </div>
                  <div className="ajd-field">
                    <div className="ajd-field-label">SIGNING TYPE</div>
                    <div className="ajd-field-value">{job.signing_type}</div>
                  </div>
                  {job.file_number && (
                    <div className="ajd-field">
                      <div className="ajd-field-label">CLIENT FILE #</div>
                      <div className="ajd-field-value">{job.file_number}</div>
                    </div>
                  )}
                  <div className="ajd-field">
                    <div className="ajd-field-label">PROPERTY ADDRESS</div>
                    <div className="ajd-field-value">
                      {job.signing_address}<br />
                      {job.signing_city}, {job.signing_state} {job.signing_zip}
                    </div>
                  </div>
                  <div className="ajd-field">
                    <div className="ajd-field-label">BORROWER(S) CONTACT</div>
                    <div className="ajd-field-value">
                      {job.borrower_name}<br />
                      {job.borrower_phone && <a href={`tel:${job.borrower_phone}`} style={{ color:'#9A7A30', textDecoration:'none', fontSize:12 }}>📞 {job.borrower_phone}</a>}
                      {job.borrower_email && <div style={{ fontSize:12, color:'#7A7870' }}>✉️ <a href={`mailto:${job.borrower_email}`} style={{ color:'inherit', textDecoration:'none' }}>{job.borrower_email}</a></div>}
                      {Array.isArray(job.additional_signers) && job.additional_signers.filter(s => (s.name||'').trim()).map((s, i) => (
                        <div key={i} style={{ marginTop:10 }}>
                          {s.name}<br />
                          {s.phone && <a href={`tel:${s.phone}`} style={{ color:'#9A7A30', textDecoration:'none', fontSize:12 }}>📞 {s.phone}</a>}
                          {s.email && <div style={{ fontSize:12, color:'#7A7870' }}>✉️ <a href={`mailto:${s.email}`} style={{ color:'inherit', textDecoration:'none' }}>{s.email}</a></div>}
                          {s.separate_address && (s.address || s.city) && (
                            <div style={{ fontSize:12, color:'#0D1B3E', marginTop:4, background:'#FDF6E3', border:'1px solid #E8D9A8', borderRadius:6, padding:'6px 10px' }}>
                              📦 Ship to: {[s.address, s.city, s.state, s.zip].filter(Boolean).join(', ')}
                            </div>
                          )}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {job.special_instructions && (
                  <div style={{ marginTop:14, background:'#EBF4FF', border:'1px solid rgba(13,27,62,0.15)', borderRadius:8, padding:'10px 14px' }}>
                    <div style={{ fontSize:10, fontWeight:700, color:'#1A3A5E', letterSpacing:'0.06em', marginBottom:4 }}>📋 SPECIAL INSTRUCTIONS</div>
                    <div style={{ fontSize:12, color:'#1A3A5E', lineHeight:1.6 }}>{job.special_instructions}</div>
                  </div>
                )}
                {job.order_notes && (
                  <div style={{ marginTop:10, background:'#FDF6E3', border:'1px solid rgba(201,168,76,0.2)', borderRadius:8, padding:'10px 14px' }}>
                    <div style={{ fontSize:10, fontWeight:700, color:'#8A5C00', letterSpacing:'0.06em', marginBottom:4 }}>💬 CLIENT NOTES</div>
                    <div style={{ fontSize:12, color:'#8A5C00', lineHeight:1.6 }}>{job.order_notes}</div>
                  </div>
                )}
              </div>
            </div>

            {/* DOCUMENTS CARD */}
            <div className="ajd-card">
              <div className="ajd-card-header">
                <div className="ajd-card-title">📁 Signing Package</div>
                <label style={{ cursor:'pointer' }}>
                  <input type="file" accept=".pdf,.jpg,.jpeg,.png" style={{ display:'none' }}
                    onChange={async e => {
                      const file = e.target.files[0]
                      if (!file) return
                      const path = `${jobId}/signing-pkg-${Date.now()}.${file.name.split('.').pop()}`
                      const { error } = await supabase.storage.from('job-documents').upload(path, file, { upsert: true })
                      if (error) { toast.error(error.message); return }
                      const { data: { publicUrl } } = supabase.storage.from('job-documents').getPublicUrl(path)
                      const { data: { user } } = await supabase.auth.getUser()
                      await supabase.from('job_documents').insert({
                        job_id: jobId, uploaded_by: user?.id, role: 'admin',
                        doc_type: 'signing_package', file_name: file.name, file_url: publicUrl, file_size: file.size,
                      })
                      toast.success('✅ Signing package uploaded!!')
                      loadJob()
                    }}
                  />
                  <span className="btn btn-primary btn-sm" style={{ pointerEvents:'none' }}>+ Upload Package</span>
                </label>
              </div>
              <div className="ajd-card-body">
                {docs.length === 0 ? (
                  <div style={{ textAlign:'center', padding:'20px 0', color:'#B8B5AB', fontSize:13 }}>
                    No documents uploaded yet — upload the signing package above!!
                  </div>
                ) : (
                  docs.map(d => (
                    <div key={d.id} style={{ display:'flex', alignItems:'center', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid #F0EEE8', gap:10 }}>
                      <div>
                        <div style={{ fontSize:13, color:'#0D1B3E' }}>{d.file_name}</div>
                        <div style={{ fontSize:11, color:'#B8B5AB' }}>
                          {new Date(d.created_at).toLocaleDateString()}
                          {d.downloaded_at && <span style={{ color:'#2D7A4F', marginLeft:8 }}>✅ Downloaded by notary</span>}
                        </div>
                      </div>
                      <a href={d.file_url} target="_blank" rel="noreferrer" className="btn btn-outline btn-sm" style={{ fontSize:11 }}>⬇️ Download</a>
                    </div>
                  ))
                )}
              </div>
            </div>

            {/* SCANBACKS CARD */}
            <div className="ajd-card">
              <div className="ajd-card-header">
                <div className="ajd-card-title">📄 Scan-Backs & QC</div>
                <span style={{ fontSize:11, color:'#7A7870' }}>{scanbacks.length} document{scanbacks.length !== 1 ? 's' : ''}</span>
              </div>
              <div className="ajd-card-body">
                {scanbacks.length === 0 ? (
                  <div style={{ textAlign:'center', padding:'20px 0', color:'#B8B5AB', fontSize:13 }}>
                    Waiting for notary to upload scan-backs!!
                  </div>
                ) : (
                  scanbacks.map(d => (
                    <ScanbackItem key={d.id} doc={d} onApprove={approveScanback} onReject={rejectScanback} />
                  ))
                )}
              </div>
            </div>

            {/* SHIPPING CARD */}
            <div className="ajd-card">
              <div className="ajd-card-header">
                <div className="ajd-card-title">📦 Shipping & Tracking</div>
                {shipping?.tracking_number && (
                  <span style={{ fontSize:11, color:'#2D7A4F', fontWeight:600 }}>✅ {shipping.carrier} · {shipping.tracking_number}</span>
                )}
              </div>
              <div className="ajd-card-body">
                <div className="ajd-grid-3" style={{ marginBottom:14 }}>
                  <div>
                    <div className="ajd-field-label">CARRIER</div>
                    <select value={carrier} onChange={e => setCarrier(e.target.value)}
                      style={{ width:'100%', padding:'8px 10px', border:'1.5px solid #E0D9CC', borderRadius:8, fontSize:13, fontFamily:'inherit' }}>
                      <option value="">Select...</option>
                      <option value="FedEx">FedEx</option>
                      <option value="UPS">UPS</option>
                      <option value="USPS">USPS</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div>
                    <div className="ajd-field-label">TRACKING #</div>
                    <input value={tracking} onChange={e => setTracking(e.target.value)} placeholder="e.g. 1Z999AA1..."
                      style={{ width:'100%', padding:'8px 10px', border:'1.5px solid #E0D9CC', borderRadius:8, fontSize:13 }} />
                  </div>
                  <div>
                    <div className="ajd-field-label">DROP-OFF DATE</div>
                    <input type="date" value={dropoff} onChange={e => setDropoff(e.target.value)}
                      style={{ width:'100%', padding:'8px 10px', border:'1.5px solid #E0D9CC', borderRadius:8, fontSize:13 }} />
                    {shipping?.shipped_at && (
                      <div style={{ fontSize:10, color:'#2D7A4F', fontWeight:600, marginTop:4 }}>
                        🕒 Auto-stamped at drop-off: {new Date(shipping.shipped_at).toLocaleString('en-US', { month:'short', day:'numeric', year:'numeric', hour:'2-digit', minute:'2-digit' })}
                      </div>
                    )}
                  </div>
                </div>
                {tracking && carrier && (
                  <a href={
                    carrier === 'FedEx' ? `https://www.fedex.com/fedextrack/?trknbr=${tracking}` :
                    carrier === 'UPS'   ? `https://www.ups.com/track?tracknum=${tracking}` :
                    carrier === 'USPS'  ? `https://tools.usps.com/go/TrackConfirmAction?tLabels=${tracking}` : '#'
                  } target="_blank" rel="noreferrer"
                  style={{ display:'inline-flex', alignItems:'center', gap:6, fontSize:11, color:'#185FA5', marginBottom:14, textDecoration:'none' }}>
                    🔗 Track this shipment →
                  </a>
                )}
                <button className="btn btn-primary btn-sm" onClick={saveShipping} disabled={savingShip}>
                  {savingShip ? 'Saving...' : '💾 Save Shipping Info'}
                </button>
                {job.receipt_url && (
                  <a href={job.receipt_url} target="_blank" rel="noreferrer"
                    style={{ display:'flex', alignItems:'center', gap:8, marginTop:14, padding:'10px 14px', background:'#F0FAF5', border:'1px solid #B8E0C8', borderRadius:8, fontSize:12, color:'#1A4A2E', fontWeight:600, textDecoration:'none' }}>
                    🧾 View notary's shipping receipt →
                  </a>
                )}
              </div>
            </div>

            {/* MESSAGES CARD */}
            <div className="ajd-card">
              <div className="ajd-card-header">
                <div className="ajd-card-title">💬 Messages</div>
              </div>
              <div style={{ padding:'0 20px 20px' }}>
                {job.client_id ? (
                  <MessagesWithTabs jobId={jobId} jobNumber={job.job_number} hasClient={!!job.client_id} />
                ) : (
                  <>
                    <div style={{ fontSize:12, fontWeight:600, color:'#7A7870', marginBottom:8, marginTop:16 }}>ADMIN ↔ NOTARY</div>
                    <JobMessages jobId={jobId} jobNumber={job.job_number} role="admin" recipientRole="notary" />
                  </>
                )}
              </div>
            </div>

          </div>

          {/* ── RIGHT COLUMN ── */}
          <div>

            {/* ASSIGNMENT CARD */}
            <div className="ajd-card">
              <div className="ajd-card-header">
                <div className="ajd-card-title">👤 Notary Assignment</div>
              </div>
              <div className="ajd-card-body">
                {notary ? (
                  <>
                    <div className="ajd-notary-card">
                      <div className="ajd-notary-name">{notary.full_name}</div>
                      <div className="ajd-notary-meta">
                        {notary.email && <div>✉️ <a href={`mailto:${notary.email}`} style={{ color:'inherit', textDecoration:'none' }}>{notary.email}</a></div>}
                        {notary.phone && <div>📞 <a href={`tel:${notary.phone}`} style={{ color:'inherit', textDecoration:'none' }}>{notary.phone}</a></div>}
                        {notary.notaries?.commission_state && <div>📍 {notary.notaries.commission_state}</div>}
                        {notary.notaries?.total_signings !== undefined && <div>⭐ {notary.notaries.avg_rating || '—'} · {notary.notaries.total_signings} signings</div>}
                      </div>
                    </div>
                    <button className="btn btn-outline btn-sm" onClick={() => setShowAssign(true)} style={{ marginTop:10, width:'100%' }}>
                      🔄 Reassign Notary
                    </button>
                  </>
                ) : (
                  <div style={{ textAlign:'center', padding:'16px 0' }}>
                    <div style={{ fontSize:13, color:'#B8B5AB', marginBottom:14 }}>No notary assigned yet!!</div>
                    <button className="ajd-action-btn ajd-action-primary" onClick={() => setShowAssign(true)}>
                      👤 Assign a Notary
                    </button>
                    <div style={{ fontSize:11, color:'#B8B5AB', margin:'12px 0 8px' }}>— OR —</div>
                    <button
                      onClick={() => setShowBlast(true)}
                      disabled={job.blast_active}
                      style={{
                        width:'100%',
                        background: job.blast_active ? '#E8E6DF' : 'linear-gradient(135deg,#8A5C00,#C9A84C)',
                        color: job.blast_active ? '#B8B5AB' : '#fff',
                        border: 'none',
                        borderRadius: 10,
                        padding: '12px 18px',
                        fontSize: 14,
                        fontWeight: 700,
                        cursor: job.blast_active ? 'not-allowed' : 'pointer',
                        fontFamily: 'inherit',
                        letterSpacing: '0.04em',
                      }}
                    >
                      {job.blast_active ? '📢 Blast Active (waiting for accept)' : '📢 BLAST to Qualified Notaries'}
                    </button>
                    {job.blast_active && (
                      <div style={{ fontSize:11, color:'#7A7870', marginTop:8, fontStyle:'italic' }}>
                        Blasted to {job.blast_recipient_count || 0} notaries — first to accept wins!!
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>

            {/* PAYMENT CARD */}
            <div className="ajd-card">
              <div className="ajd-card-header">
                <div className="ajd-card-title">💰 Payment</div>
              </div>
              <div className="ajd-card-body">
                <div className="ajd-grid-2" style={{ marginBottom:14 }}>
                  <div>
                    <div className="ajd-field-label">CLIENT INVOICE ($)</div>
                    <input type="number" value={invoiceAmt} onChange={e => setInvoiceAmt(e.target.value)} placeholder="0.00"
                      style={{ width:'100%', padding:'8px 10px', border:'1.5px solid #E0D9CC', borderRadius:8, fontSize:13 }} />
                  </div>
                  <div>
                    <div className="ajd-field-label">NOTARY PAY ($)</div>
                    <input type="number" value={notaryPayAmt} onChange={e => setNotaryPayAmt(e.target.value)} placeholder="0.00"
                      style={{ width:'100%', padding:'8px 10px', border:'1.5px solid #E0D9CC', borderRadius:8, fontSize:13 }} />
                  </div>
                </div>

                {/* LCA cut auto-calculated */}
                {invoiceAmt && notaryPayAmt && (
                  <div style={{ background:'#F8F7F4', borderRadius:8, padding:'10px 14px', marginBottom:14, fontSize:12 }}>
                    <div style={{ display:'flex', justifyContent:'space-between', marginBottom:4 }}>
                      <span style={{ color:'#7A7870' }}>LCA Cut</span>
                      <strong style={{ color:'#C9A84C' }}>${(Number(invoiceAmt) - Number(notaryPayAmt)).toFixed(2)}</strong>
                    </div>
                    <div style={{ display:'flex', justifyContent:'space-between' }}>
                      <span style={{ color:'#7A7870' }}>Margin</span>
                      <strong style={{ color:'#2D7A4F' }}>
                        {invoiceAmt > 0 ? Math.round(((Number(invoiceAmt) - Number(notaryPayAmt)) / Number(invoiceAmt)) * 100) : 0}%
                      </strong>
                    </div>
                  </div>
                )}

                <button className="btn btn-outline btn-sm" onClick={savePayments} disabled={savingPay} style={{ width:'100%', marginBottom:10 }}>
                  {savingPay ? 'Saving...' : '💾 Save Amounts'}
                </button>

                {/* Payment status */}
                <div>
                  <div className="ajd-pay-row">
                    <span className="ajd-pay-label">Client Payment</span>
                    <span className="ajd-pay-status" style={{
                      background: payments?.client_payment_status === 'paid' ? '#EAF5EE' : '#FDF6E3',
                      color:      payments?.client_payment_status === 'paid' ? '#2D7A4F' : '#8A5C00',
                    }}>
                      {payments?.client_payment_status === 'paid'
                        ? `✅ Paid ${payments?.client_payment_date ? new Date(payments.client_payment_date).toLocaleDateString() : ''}`
                        : '⏳ Pending'}
                    </span>
                  </div>
                  <div className="ajd-pay-row">
                    <span className="ajd-pay-label">Notary Payment</span>
                    <span className="ajd-pay-status" style={{
                      background: payments?.notary_payment_status === 'paid' ? '#EAF5EE' : payments?.notary_payment_status === 'scheduled' ? '#EBF4FF' : '#FDF6E3',
                      color:      payments?.notary_payment_status === 'paid' ? '#2D7A4F' : payments?.notary_payment_status === 'scheduled' ? '#185FA5' : '#8A5C00',
                    }}>
                      {payments?.notary_payment_status === 'paid'
                        ? `✅ Paid ${payments?.notary_payment_date ? new Date(payments.notary_payment_date).toLocaleDateString() : ''}`
                        : payments?.notary_payment_status === 'scheduled'
                        ? `📅 Scheduled ${payments?.notary_payment_date ? new Date(payments.notary_payment_date).toLocaleDateString() : ''}`
                        : '⏳ Pending'}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            {/* STATUS TIMELINE CARD */}
            <div className="ajd-card">
              <div className="ajd-card-header">
                <div className="ajd-card-title">🕐 Status Timeline</div>
              </div>
              <div className="ajd-card-body">
                <MilestoneTracker status={job.status} jobType={job.job_type} scanBacksRequired={job.scan_backs_required} />
                <div style={{ fontSize:11, fontWeight:700, color:'#B8B5AB', letterSpacing:'0.06em', textTransform:'uppercase', borderTop:'1px solid #F0EEE8', paddingTop:12, marginBottom:10 }}>Event History</div>
                {timeline.length === 0 ? (
                  <div style={{ textAlign:'center', padding:'16px 0', color:'#B8B5AB', fontSize:13 }}>
                    No status events yet!!
                  </div>
                ) : (
                  <ul className="ajd-timeline">
                    {timeline.map((event, i) => {
                      const cfg = STATUS_CONFIG[event.status] || { dot:'#B8B5AB', label: event.status }
                      return (
                        <li key={event.id || i} className="ajd-timeline-item">
                          <div className="ajd-timeline-dot" style={{ background: cfg.dot }} />
                          <div className="ajd-timeline-content">
                            <div className="ajd-timeline-status">{cfg.label || event.status}</div>
                            <div className="ajd-timeline-meta">
                              {new Date(event.created_at).toLocaleString()} · {event.created_by_role || 'system'}
                            </div>
                            {event.note && <div className="ajd-timeline-note">{event.note}</div>}
                          </div>
                        </li>
                      )
                    })}
                  </ul>
                )}
              </div>
            </div>

            {/* RATINGS & FEEDBACK CARD — admin sees BOTH directions */}
            <div className="ajd-card">
              <div className="ajd-card-header">
                <div className="ajd-card-title">⭐ Ratings &amp; Feedback</div>
              </div>
              <div className="ajd-card-body">
                <div style={{ marginBottom:16 }}>
                  <div style={{ fontSize:11, fontWeight:700, color:'#7A7870', letterSpacing:'0.06em', textTransform:'uppercase', marginBottom:6 }}>Client → Notary</div>
                  {job.client_rating ? (
                    <>
                      <div style={{ fontSize:20, letterSpacing:2 }}><span style={{ color:'#C9A84C' }}>{'★'.repeat(job.client_rating)}</span><span style={{ color:'#E8E6DF' }}>{'★'.repeat(5 - job.client_rating)}</span></div>
                      {job.client_rating_comment && <div style={{ fontSize:13, color:'#0D1B3E', marginTop:6, fontStyle:'italic' }}>&ldquo;{job.client_rating_comment}&rdquo;</div>}
                      {job.client_rated_at && <div style={{ fontSize:11, color:'#B8B5AB', marginTop:4 }}>Rated {new Date(job.client_rated_at).toLocaleString()}</div>}
                    </>
                  ) : <div style={{ fontSize:13, color:'#B8B5AB', fontStyle:'italic' }}>No client rating yet</div>}
                </div>
                <div style={{ borderTop:'1px solid #F0EEE8', paddingTop:14 }}>
                  <div style={{ fontSize:11, fontWeight:700, color:'#7A7870', letterSpacing:'0.06em', textTransform:'uppercase', marginBottom:6 }}>🔒 Notary → Client &nbsp;(private)</div>
                  {job.notary_rating ? (
                    <>
                      <div style={{ fontSize:20, letterSpacing:2 }}><span style={{ color:'#C9A84C' }}>{'★'.repeat(job.notary_rating)}</span><span style={{ color:'#E8E6DF' }}>{'★'.repeat(5 - job.notary_rating)}</span></div>
                      {job.notary_rating_comment && <div style={{ fontSize:13, color:'#0D1B3E', marginTop:6, fontStyle:'italic' }}>&ldquo;{job.notary_rating_comment}&rdquo;</div>}
                      {job.notary_rated_at && <div style={{ fontSize:11, color:'#B8B5AB', marginTop:4 }}>Rated {new Date(job.notary_rated_at).toLocaleString()}</div>}
                    </>
                  ) : <div style={{ fontSize:13, color:'#B8B5AB', fontStyle:'italic' }}>No notary feedback yet</div>}
                </div>
              </div>
            </div>

            {/* ACTIONS CARD */}
            <div className="ajd-card">
              <div className="ajd-card-header">
                <div className="ajd-card-title">⚡ Actions</div>
              </div>
              <div className="ajd-card-body">
                <div className="ajd-actions">
                  {/* Assign notary */}
                  {['new', 'awaiting_assignment'].includes(job.status) && (
                    <button className="ajd-action-btn ajd-action-primary" onClick={() => setShowAssign(true)} disabled={saving}>
                      👤 Assign Notary
                    </button>
                  )}
                  {/* Awaiting notary response — stale-offer tools + manual accept */}
                  {job.status === 'assigned' && (
                    <>
                      {/* ⏰ STALE OFFER WARNING — if >2hr since assignment, show alert */}
                      {(() => {
                        const offeredAt = job.notary_offered_at ? new Date(job.notary_offered_at) : null
                        if (!offeredAt) return null
                        const minutesElapsed = Math.floor((Date.now() - offeredAt.getTime()) / 60000)
                        if (minutesElapsed < 120) return null
                        const hoursElapsed = Math.floor(minutesElapsed / 60)
                        return (
                          <div style={{ background:'#FEF3E2', border:'1px solid #F59E0B', borderRadius:8, padding:'10px 14px', marginBottom:10, fontSize:12 }}>
                            <div style={{ fontWeight:700, color:'#9A6800', marginBottom:6 }}>
                              ⏰ STALE OFFER — {hoursElapsed}h+ since notary was notified!!
                            </div>
                            <div style={{ color:'#7A5500', marginBottom:8 }}>
                              No response yet. Consider reassigning or unassigning to BLAST.
                            </div>
                            <button
                              onClick={async () => {
                                if (!window.confirm('Unassign this notary and return job to "Awaiting Assignment"?\n\nYou can then assign manually or use BLAST to find another notary.')) return
                                try {
                                  await supabase.from('jobs').update({
                                    notary_id: null,
                                    status: 'awaiting_assignment',
                                  }).eq('id', job.id)
                                  await logStatusEvent(job.id, 'awaiting_assignment', 'admin', `⏰ Auto-expired stale offer (${hoursElapsed}h+ no response) — ready for reassignment`)
                                  toast.success('🔄 Offer expired. Job is back in queue!!')
                                  loadJob()
                                } catch(err) {
                                  toast.error(err.message)
                                }
                              }}
                              style={{
                                background:'#9A6800',
                                color:'#fff',
                                border:'none',
                                borderRadius:6,
                                padding:'6px 12px',
                                fontSize:11,
                                fontWeight:600,
                                cursor:'pointer',
                                fontFamily:'inherit',
                              }}
                            >
                              ⏰ Expire This Offer Now
                            </button>
                          </div>
                        )
                      })()}
                      <button className="ajd-action-btn ajd-action-success" disabled={saving}
                        onClick={() => { if(window.confirm('Mark as accepted? (Use if notary confirmed by phone)')) updateStatus('accepted', 'Admin confirmed acceptance') }}>
                        ✅ Confirm Notary Accepted
                      </button>
                      <button className="ajd-action-btn ajd-action-outline" onClick={() => setShowAssign(true)} disabled={saving}>
                        🔄 Reassign to Different Notary
                      </button>
                    </>
                  )}
                  {/* Canonical signing-day ladder */}
                  {job.status === 'accepted' && (
                    <button className="ajd-action-btn ajd-action-primary" onClick={() => updateStatus('on_the_way', 'Notary on the way')} disabled={saving}>
                      🚗 Mark Notary On The Way
                    </button>
                  )}
                  {job.status === 'on_the_way' && (
                    <button className="ajd-action-btn ajd-action-primary" onClick={() => updateStatus('arrived', 'Notary arrived')} disabled={saving}>
                      📍 Mark Notary Arrived
                    </button>
                  )}
                  {job.status === 'arrived' && (
                    <button className="ajd-action-btn ajd-action-primary" onClick={() => updateStatus('completed', 'Signing completed')} disabled={saving}>
                      ✍️ Mark Signing Completed
                    </button>
                  )}
                  {/* 👤 INDIVIDUAL — paid upfront, no scans/shipping/invoice. One clean finish. */}
                  {(job.job_type === 'individual' || job.scan_backs_required === false) && !['closed','cancelled','new','awaiting_assignment','declined'].includes(job.status) && (
                    <button className="ajd-action-btn ajd-action-success" disabled={saving}
                      onClick={() => { if(window.confirm(`Complete & close individual order ${job.job_number}? (No scan-backs — paid upfront.)`)) updateStatus('closed', '✓ Individual order completed & closed') }}>
                      ✓ Complete &amp; Close (Individual)
                    </button>
                  )}
                  {/* Scanbacks uploaded — company orders only */}
                  {job.status === 'completed' && job.job_type !== 'individual' && job.scan_backs_required !== false && (
                    <button className="ajd-action-btn ajd-action-primary" onClick={() => updateStatus('scanbacks_uploaded', 'Scan-backs uploaded')} disabled={saving}>
                      📄 Mark Scan-Backs Uploaded
                    </button>
                  )}
                  {/* Approve scanbacks — company orders only */}
                  {job.status === 'scanbacks_uploaded' && job.job_type !== 'individual' && job.scan_backs_required !== false && (
                    <button className="ajd-action-btn ajd-action-success" onClick={() => updateStatus('client_approved', 'Admin approved scan-backs')} disabled={saving}>
                      ✅ Approve Scan-Backs
                    </button>
                  )}
                  {/* Send invoice to client — company orders only (individuals pay upfront) */}
                  {job.status === 'client_approved' && !job.invoice_sent_at && job.job_type !== 'individual' && job.scan_backs_required !== false && (
                    <button className="ajd-action-btn ajd-action-success" onClick={sendInvoice} disabled={saving}>
                      📧 Send Invoice to Client
                    </button>
                  )}
                  {/* Mark client paid — only after the invoice has been sent */}
                  {['client_approved', 'completed', 'awaiting_review'].includes(job.status) && job.invoice_sent_at && payments?.client_payment_status !== 'paid' && (
                    <button className="ajd-action-btn ajd-action-warning" onClick={markClientPaid} disabled={saving}>
                      💳 Mark Client Payment Received
                    </button>
                  )}
                  {/* Schedule notary payment */}
                  {job.status === 'payment_received' && payments?.notary_payment_status === 'pending' && (
                    <button className="ajd-action-btn ajd-action-success" onClick={releaseNotaryPayment} disabled={saving}>
                      📅 Schedule Notary Payment (Tue→Fri Rule)
                    </button>
                  )}
                  {/* Mark notary paid */}
                  {payments?.notary_payment_status === 'scheduled' && (
                    <button className="ajd-action-btn ajd-action-success" onClick={markNotaryPaid} disabled={saving}>
                      💰 Mark Notary Paid
                    </button>
                  )}
                  {/* Close order */}
                  {job.status === 'notary_paid' && (
                    <button className="ajd-action-btn ajd-action-outline" onClick={() => { if(window.confirm('Close this order?')) updateStatus('closed', 'Order closed') }} disabled={saving}>
                      🔒 Close Order
                    </button>
                  )}
                  {/* Cancel */}
                  {!['closed','cancelled'].includes(job.status) && (
                    <button className="ajd-action-btn ajd-action-danger" onClick={() => { if(window.confirm('Cancel this order? This cannot be undone!!')) updateStatus('cancelled', 'Order cancelled by admin') }} disabled={saving} style={{ marginTop:8 }}>
                      ❌ Cancel Order
                    </button>
                  )}
                  {/* Already closed */}
                  {['closed','cancelled'].includes(job.status) && (
                    <div style={{ textAlign:'center', padding:'12px 0', color:'#B8B5AB', fontSize:13 }}>
                      This order is {job.status}
                    </div>
                  )}
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </>
  )
}

// ── SCANBACK ITEM COMPONENT ───────────────────────────────────
function ScanbackItem({ doc, onApprove, onReject }) {
  const [rejecting, setRejecting] = useState(false)
  const [reason,    setReason]    = useState('')

  return (
    <div style={{ padding:'12px 0', borderBottom:'1px solid #F0EEE8' }}>
      <div style={{ display:'flex', alignItems:'center', justifyContent:'space-between', gap:10, flexWrap:'wrap' }}>
        <div>
          <div style={{ fontSize:13, color:'#0D1B3E', fontWeight:500 }}>{doc.file_name}</div>
          <div style={{ fontSize:11, color:'#B8B5AB', marginTop:2 }}>{new Date(doc.created_at).toLocaleString()}</div>
        </div>
        <div style={{ display:'flex', gap:6, alignItems:'center', flexWrap:'wrap' }}>
          <a href={doc.file_url} target="_blank" rel="noreferrer" className="btn btn-outline btn-sm" style={{ fontSize:11 }}>👁️ View</a>
          {doc.qc_status !== 'approved' && (
            <>
              <button onClick={() => onApprove(doc.id)} className="btn btn-primary btn-sm" style={{ fontSize:11, background:'#2D7A4F', borderColor:'#2D7A4F' }}>
                ✅ Approve
              </button>
              <button onClick={() => setRejecting(r => !r)} className="btn btn-outline btn-sm" style={{ fontSize:11, color:'#E24B4A', borderColor:'#E24B4A' }}>
                ❌ Reject
              </button>
            </>
          )}
          {doc.qc_status === 'approved' && (
            <span style={{ fontSize:11, fontWeight:700, color:'#2D7A4F', background:'#EAF5EE', padding:'4px 10px', borderRadius:20 }}>✅ Approved</span>
          )}
        </div>
      </div>
      {rejecting && (
        <div style={{ marginTop:10, display:'flex', gap:8 }}>
          <input value={reason} onChange={e => setReason(e.target.value)} placeholder="Reason for rejection..."
            style={{ flex:1, padding:'7px 10px', border:'1.5px solid #E24B4A', borderRadius:8, fontSize:12 }} />
          <button onClick={() => { onReject(doc.id, reason); setRejecting(false) }}
            className="btn btn-sm" style={{ background:'#E24B4A', color:'#fff', border:'none', borderRadius:8, fontSize:11, cursor:'pointer', padding:'7px 14px' }}>
            Send
          </button>
        </div>
      )}
      {doc.qc_status === 'rejected' && doc.qc_correction_notes && (
        <div style={{ marginTop:8, background:'#FDF2F2', border:'1px solid rgba(226,75,74,0.2)', borderRadius:6, padding:'8px 10px', fontSize:11, color:'#C0392B' }}>
          <strong>Correction notes:</strong> {doc.qc_correction_notes}
        </div>
      )}
    </div>
  )
}
